<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.documentDetail.comments.modal.title')"
    @close="closeDialog"
    max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12 flex flex-column">
        <textarea
          v-validate="{ required: true }"
          name="comments"
          rows="5"
          v-model="comment"
          class="w-full h-32 p-4 border border-solid border-dark-300 rounded"
          :placeholder="$t('message.documentDetail.comments.modal.body')"
        />
        <div class="text-zt-danger text-zt-base mt-2" v-if="errors.has('comments')">
        <span>
          {{ errors.first('comments') }}
        </span>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="close-dialog"
        >
          {{ $t('message.documentDetail.comments.modal.buttonCancel') }}
        </zt-button>
        <zt-button
          class="w-25"
          :loader="isLoading"
          :disabled="isLoading || !comment"
          @click="confirm"
          data-vs-button="confirm-add"
        >
          {{ $t('message.documentDetail.comments.modal.buttonAdd') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
export default {
  name: 'ObservationAddDialogDialog',
  inject: ['activeAddDialog', 'addObservation'],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active() {
      this.isLoading = false
      this.comment = ''
    }
  },
  data() {
    return {
      isLoading: false,
      comment: ''
    }
  },
  methods: {
    closeDialog() {
      if (this.isLoading) return
      this.activeAddDialog(false)
    },
    async confirm() {
      try {
        this.isLoading = true
        await this.addObservation({
          comment: this.comment
        })
        this.isLoading = false
        this.closeDialog()
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #eeeeee;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
      0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: 0.375rem !important;
  }
  button.button-cancel {
    color: #707070 !important;
    background-color: transparent !important;
  }
}
</style>
